import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { AccountService } from '../../../services/account.service';
import { catchError, finalize } from 'rxjs/operators';
import {  BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer, SelectionModel } from '@angular/cdk/collections';
import { AccountDataSourceService } from '../../../services/account-data-source.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeleteAccountDialogComponent } from '../delete-account-dialog/delete-account-dialog.component';
import { ChangeAccstatusDialogComponent } from '../change-accstatus-dialog/change-accstatus-dialog.component';
import { PaginationService } from '../../../services/pagination.service';
import { VerifyAccountDialogComponent } from '../../../shared/components/verify-account-dialog/verify-account-dialog.component';
import { EmailVerifyDialogComponent } from '../../../shared/components/email-verify-dialog/email-verify-dialog.component';
import { ChangePhoneNumberComponent } from '../change-phone-number/change-phone-number.component';
import { UpdateSalesIdDialogComponent } from '../updat-salesid/update-salesid-dialog.component';
import { QuestionUploadComponent } from '../account-filter/question-upload/question-upload.component';
import { ApplyLabelComponent } from '../account-filter/apply-label/apply-label.component';
import { AccountUserService } from 'src/app/services/account-user.service';
import { SendMessageComponent } from '../send-message/send-message.component';
import { CouponService } from 'src/app/services/coupon.service';
import { PayProfileUploadComponent } from '../account-filter/payprofile-upload/payprofile-upload.component';
import { CustomizedJsonUploadComponent } from '../account-filter/customizedjson-upload/customizedjson-upload.component';
import { ChangeStatusRealComponent } from '../change-status-real/change-status-real.component';
import { ConsumerslistUploadComponent } from '../account-filter/consumerslist-upload/consumerslist-upload.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { JadeeHomeoComponent } from '../jaldee-homeo/jaldee-homeo.component';
// import { MatPaginator } from '@angular/material/paginator';




@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css'],
  providers: [AccountListComponent]
})
export class AccountListComponent implements OnInit , OnDestroy {


  accountsList: any;
  accountCount: number;
  tableFilters = '';
  accountData: any = {};

  // public service_dataSource = new MatTableDataSource<any>();
  // dataSource = new AccountDataSource(this.accountService, this.accData);

  selectedRowIndex = -1;

  selectAccountname = '';

  showToolBar = false;

  accountDetails: any;
  pageSize = 100;
  isIndependent_sp = true;
  corpid = true;
  // displayedColumns = ['select','id', 'encodeid', 'businessName', 'accountType', 'accountLinkedPhNo', 'serviceSector', 'serviceSubSector',
  //   'baseLocation', 'status',
  //   'verifyLevel', 'createdDate', 'claimStatus' , 'type'];
  //   displayedColumns1 = ['id', 'encodeid', 'businessName', 'accountType', 'accountLinkedPhNo', 'serviceSector', 'serviceSubSector',
  //   'baseLocation', 'status',
  //   'verifyLevel', 'createdDate', 'claimStatus' , 'type'];
  //   displayedColumnss = ['claimStatus'];
  // @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  type: string;
  accountCompleteInfo: any;
  accountType: any;
  corpId: any;
  verifyLevel: any;
  showpaymentSettingbtn = true;
  showChangePhbtn = true;
  showRejectEmailbtn = true;
  bookingType;
  stat_type: any;
  stat_datetype: any;
  includeTest: any;
  start_date: any;
  applied_filter: any;
  end_date: any;
  date_category: any;
  mode_selection;
  teleservice_data: boolean;
  isTeleservice: string;
  statType: string;
  StatDateType: string;
  showToken;
  providerLabels: any = [];
  allLabels: any = [];
  unverifyaccounts: any;
  unvrifynew: any;
  account: any;
  selection = new SelectionModel(true, []);
  accounts: any;
  accDatas: any;
  showMessage: boolean;
  accId: any;
  selectedcustomersformsg: any = [];
  custArr: any = [];
  spData: any = {}
  fromOffer: boolean;
  fromDashboard: boolean;
  api_loading = true;
  first: any;
  rows: any;
  selectAll: boolean = false;
  selectedAccounts;
  constructor(
    private accountService: AccountService,
    private couponService: CouponService,
    private accountuserService: AccountUserService,
    private accData: AccountDataSourceService,
    private router: Router,
    private route: ActivatedRoute, private dialog: MatDialog) {

    // this.accData.cast.subscribe(accountCount => { console.log('accountCount' + accountCount); this.accountCount = accountCount; });
    this.accData.toolbar.subscribe(value => { console.log('toolbar' + value); this.showToolBar = value; });
    this.showToolBar = false;
    this.getLabel(this.tableFilters, 'false', 0, 100);
    this.spData = this.couponService.retriveSpData();
    this.accountData = this.accountService.retriveAccountData();
    if (this.accountData.flag === true) {
      this.tableFilters = this.accountData.filterParam;      
      // this.accountCount = this.accountData.count;
      this.accountData.flag = false;
      this.accountService.storeAccountData(this.accountData);
    } else if (this.spData !== '{}' && this.spData.flag === true) {
      this.tableFilters = this.accountData.filterParam;
      // this.accountCount = this.accountData.count;
      this.accountData.flag = false;
      this.accountService.storeAccountData(this.accountData);
    } else {
      if (this.accountData.filterParam) {
        this.tableFilters = this.accountData.filterParam;
      } else {
        this.tableFilters = '';
      }
    }
    this.getTotalCount();
  }

  ngOnInit() {
    
    // setTimeout(() => {
      // 
    // this.pagination.paginator$
    // .subscribe(result => {
    //   this.paginator.pageIndex = result;
      
    //   // this.paginator._intl.getRangeLabel.arguments(this.paginator.page,this.paginator.pageIndex,this.accountCount)
    // });
    //  
    // 
    // if (this.accountData.flag === true) {
    // this.tableFilters = this.accountData.filterParam;
    // this.accountCount = this.accountData.count;
    // const count = (this.pageSize * (this.paginator.pageIndex + 1)) - this.pageSize;
    // this.dataSource.loadAccountData(this.tableFilters, 'false', count, this.pageSize);
    // this.getTotalCount();
    // this.accountData.flag = false;
    // this.accountService.storeAccountData(this.accountData);
    // }
    // else if (this.spData !== '{}' && this.spData.flag === true) {
    //   this.tableFilters = this.spData.filterParam;
    //   this.accountCount = this.spData.count;
    //   const count = (this.pageSize * (this.paginator.pageIndex + 1)) - this.pageSize;
    //   this.dataSource.loadAccountData_byOffer(this.tableFilters, 'false', count, this.pageSize);
    //   this.spData.flag = false;
    //   this.couponService.storeSpData(this.spData);
    //   }
    // else {
    // if (this.accountData.filterParam) {
    //   this.tableFilters = this.accountData.filterParam;
    // } else {
    //   this.tableFilters = '';
    // }
    // this.getTotalCount();
    // const count = (this.pageSize * (this.paginator.pageIndex + 1)) - this.pageSize;
    // this.dataSource.loadAccountData(this.tableFilters, 'false', count, this.pageSize);
    // }
    // console.log("Hereee");
    // this.pagination.resetPage(0);
      //  }
        
    // this.paginator.page
    //   .pipe(
        // tap(() => 
        // this.loadAccountsPage();
        // this.changeDetectorRef.detectChanges();
        // )
      // )
      // .subscribe();
    // }, 1000);
  
    

   
  }
  ngAfterViewInit() {
    this.showToolBar = false;
   
  
   
  }
  // loadSalesChannelPage() {
  //   // const count = 10;
  //   console.log(this.paginator.pageIndex);
  //   const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
  //   this.dataSource.loadToken(
  //     this.tableFilters
  //  );

  // }
  setPaginationProperties() {

    // this.pagination.resetPage(this.paginator.pageIndex);
  }
 // onRowClicked(row) {
  onRowClicked(event) {
    let row=event.data;
    console.log("Row:", row);
    this.accData.setAccountToolBarVal(true);
    this.selectedRowIndex = row.account.id;
    this.accountType = row.account.accountType;
    this.corpId = row.account.corpId;
    this.selectAccountname = row.account.businessName;
    this.accountDetails = row.account;
    this.accountCompleteInfo = row;
    this.verifyLevel = row.account.verifyLevel;
    if (this.accountType === 'INDEPENDENT_SP' && this.accountDetails.status === 'ACTIVE') {
      this.isIndependent_sp = true;
    } else {
      this.isIndependent_sp = false;
    }
    if (this.corpId === 0) {
      this.corpid = true;
    } else {
      this.corpid = false;
    }
    this.showActionBtns();

  }
  showActionBtns() {
    this.showpaymentSettingbtn = true;
    this.showChangePhbtn = true;
    this.showRejectEmailbtn = true;
    if (this.accountDetails.status === 'INACTIVE' || this.accountDetails.claimStatus === 'Unclaimed') {
      this.showpaymentSettingbtn = false;
      this.showChangePhbtn = false;
      this.showRejectEmailbtn = false;
    }
  }
  accountInfo() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'accountdetails'], { relativeTo: this.route });
  }
  licenseDetails() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'licensedetails'], { relativeTo: this.route });
  }
  // getPaymentSettings() {
  //   this.router.navigate(['../../view', this.selectedRowIndex, 'paymentSettings'], { relativeTo: this.route });
  // }
  getPaymentSettings() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'paymentdetails'], { relativeTo: this.route });
  }
  getPaymentTransactions() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'transactions'], { relativeTo: this.route });
  }
  getInvoices() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'invoice'], { relativeTo: this.route });
  }
  getPaymentHistory() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'history'], { relativeTo: this.route });
  }
  getQuestionView() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'question'], { relativeTo: this.route });
  }
  enablePwa() {
    this.router.navigate(['../../view', this.selectedRowIndex, 'pwa'], { relativeTo: this.route });
  }
  // gethistorys() {
  //   this.router.navigate(['../../view', this.selectedRowIndex, 'virtualcalling'], { relativeTo: this.route });
  // }
  deleteAccount() {
    const dialogRef = this.dialog.open(DeleteAccountDialogComponent, {
      width: '600px',
      data: { 'id': this.selectedRowIndex, 'accountType': this.accountType, 'details': this.accountDetails }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  UpdateSalesId() {
    const dialogRef = this.dialog.open(UpdateSalesIdDialogComponent, {
      width: '600px',
      data: this.accountDetails.id
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  changeStatus() {
    const dialogRef = this.dialog.open(ChangeAccstatusDialogComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  changeRealtoNonreal() {
    const dialogRef = this.dialog.open(ChangeStatusRealComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  jaldeeHomeo() {
    const dialogRef = this.dialog.open(JadeeHomeoComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  questUpload() {
    const dialogRef = this.dialog.open(QuestionUploadComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  consumerUpload() {
    const dialogRef = this.dialog.open(ConsumerslistUploadComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  payProfileUploadJson(){
    const dialogRef = this.dialog.open(PayProfileUploadComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  customizedJsonUpload(){
    const dialogRef = this.dialog.open(CustomizedJsonUploadComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  applyLabel() {
    const dialogRef = this.dialog.open(ApplyLabelComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result.data === 'data'){
        this.gotolabels();
      }
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  gotolabels(){
     this.router.navigate(['../../../labels/list'],{ relativeTo: this.route });
  }
  verify() {
    if ((this.accountDetails.verifyLevel === 'NONE')) {
      this.type = 'add';
    } else {
      this.type = 'edit';
    }
    const dialogRef = this.dialog.open(VerifyAccountDialogComponent, {
      width: '800px',
      data: { 'account': this.accountCompleteInfo, 'type': this.type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  getLabel(filter,sortDirection, count, pageSize) {
    this.providerLabels = [];
    this.accountuserService.getLabels(filter,sortDirection,
      count, pageSize).subscribe(data => {
      this.allLabels = data;
      // console.log(this.allLabels);
      this.providerLabels = this.allLabels.filter(label => label.status === 'ENABLED');
      // this.getDisplayname()
    });
  }
  getDisplayname(label) {
    for (let i = 0; i < this.allLabels.length; i++) {
      if (this.allLabels[i].label === label) {
        return this.allLabels[i].displayName;
      }
    }
  }
  updateJaldeeVerify() {
    this.router.navigate(['../../../labels/list'],
    { relativeTo: this.route });
    this.router.navigate(['../../jaldeeVerification/update', { 'type': 'account', 'id': this.accountDetails.id }],
      { relativeTo: this.route });
  }
  changeAccountPhoneno() {
    const dialogRef = this.dialog.open(ChangePhoneNumberComponent, {
      width: '600px',
      data: this.accountDetails.id
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  sendMsg(){
    this.custArr =[];
    this.custArr = this.selection.selected;
    // console.log(this.custArr)
    const dialogRef = this.dialog.open(SendMessageComponent, {
      width: '600px',
      data: { 'filter': this.tableFilters, 'accId': this.custArr }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selection = new SelectionModel(true, []);
      this.showMessage = false;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadAccountsPage();
    });
  }
  reject_mail() {
    const dialogRef = this.dialog.open(EmailVerifyDialogComponent, {
      width: '600px',
      height: 'auto',
      data: { 'account': this.accountCompleteInfo, 'type': 'provider' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadAccountsPage();
    });
  }
  loadAccountsPage() {
    // this.accountData = this.accountService.retriveAccountData();
    // if (this.accountData.filterParam !== undefined) {
    //   this.tableFilters = this.accountData.filterParam;
    // } else {
    //   this.tableFilters = '';
    // }
    // console.log('tableFilterssss........' + this.tableFilters);
    // const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - this.pageSize;
    // this.dataSource.loadAccountData(
    //   this.tableFilters,
    //   'false',
    //   count,
    //   this.paginator.pageSize);
  }
  getAccountsList(event) {
    console.log(event);
    this.accountService.getAccountsData(this.tableFilters, true,
      event.first, event.rows).subscribe(
        accounts => {
          console.log("Accounts:", accounts);
          this.accountsList = accounts;
          this.api_loading = false;
        }
      );
  }

onSelectionChange(value) {  
  this.selectAll = value.length === this.accountsList.length;
  this.selectedAccounts = value;
    console.log("Selected :",value);

  // if(value.length === this.accountsList.length){
  //   console.log("Selected All :",value);
  //   this.selectAll = true;
  //   this.selectedAccounts = value;
  // }
  // else{
  //   console.log("Selected One :",value);
  //   this.selectAll = false;
  //   this.selectedAccounts = value;
  // }
}

onSelectAllChange(event) {
  const checked = event.checked;
  if (checked) {
      // this.customerService.getCustomers().then(res => {
          this.selectedAccounts = this.accountsList;
          this.selectAll = true;
      // });
  }
  else {
      this.selectedAccounts = [];
      this.selectAll = false;
  }
}
reset() {
    this.first = 0;
}

isLastPage(): boolean {
    return this.accountsList ? this.first === (this.accountsList.length - this.rows): true;
}

isFirstPage(): boolean {
    return this.accountsList ? this.first === 0 : true;
}

  getTotalCount() {
    this.accountService.getTotalFilterCount(this.tableFilters)
      .subscribe(res => {
        this.accData.setAccountCount(res);
        this.accountCount = res;
      });
  }
  ngOnDestroy() {
    this.selectedRowIndex = -1;
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    // const numRows = this.dataSource.accDatas.length;
    // return numSelected === numRows
  }
  // masterToggle($event) {
  //   this.isAllSelected() ?
  //   this.selection.clear() :
  // this.dataSource.accDatas.forEach(row => this.selection.select(row));
  //   let masterValue = $event.target.checked;
  //   if(masterValue){
  //     this.showMessage = true;
  //   }
  //   else{
  //     this.showMessage = false;
  //   }
  
  // }
  selectionCh($event) {
    this.custArr = this.selection.selected;
    let value = $event.target.checked;
    if(value>0){
      this.showMessage = true;
    }
    else{
      this.showMessage = false;  
    }

}
}

// export class AccountDataSource implements DataSource<any> {
  // selection = new SelectionModel(true, []);
  // accDatas: any;
  // data: any;
  // constructor(private accountService: AccountService, private accData: AccountDataSourceService) {
  // }
  // public loadingSubject = new BehaviorSubject<boolean>(false);

  // public loading$ = this.loadingSubject.asObservable();
  // connect(collectionViewer: CollectionViewer): Observable<any> {
  //   return this.accData.accountSubject.asObservable();
  // }
  // disconnect(collectionViewer: CollectionViewer): void {
  //   this.accData.accountSubject.complete();
  //   this.accData.loadingSubject.complete();
  // }
  // loadAccountData(filter,
  //   sortDirection, count, pageSize) {
  //   this.accData.loadingSubject.next(true);
  //   this.accountService.getAccountsData(filter, sortDirection,
  //     count, pageSize).pipe(
  //       catchError(() => of([])),
  //       finalize(() => this.accData.loadingSubject.next(false))
  //     )
  //     .subscribe(
  //       accounts => {
  //         console.log(accounts);
  //         this.accDatas = accounts;
  //         this.accData.accountSubject.next(accounts);
  //       }
  //     );
      
  // }

  // loadAccountData_byOffer(filter,
  //   sortDirection, count, pageSize) {
    // this.accData.loadingSubject.next(true);
    // this.accountService.getAccountsData_byOffer(filter, sortDirection,
    //   count, pageSize).pipe(
    //     catchError(() => of([])),
    //     finalize(() => this.accData.loadingSubject.next(false))
    //   )
      // .subscribe(
      //   accounts => {
      //     this.accDatas = accounts;
      //     this.accData.accountSubject.next(accounts);
      //   }
      // );   
//   }
// }
